<template>
    <div class="row">
        <div class="col">
            <users-crud></users-crud>
        </div>
    </div>
</template>

<script>
    import UsersCrud from './users/UsersCrud';

    export default {
        components: {
            UsersCrud
        }
    }
</script>
